import { create } from "zustand";
import { persist } from "zustand/middleware";
import createSelectors from "./selectors";

export type SidebarStoreProps = {
  isOpenSidebar: boolean;
  setSideBarState: (isOpen: boolean) => void; 
};

const useSidebarStore = create<SidebarStoreProps>()(
  persist(
    (set) => ({
      isOpenSidebar: true,
      setSideBarState: (isOpen) => set({ isOpenSidebar: isOpen }),
    }),
    {
      name: "sidebar-store",
    }
  )
);

export default createSelectors(useSidebarStore);
